// Module
var code = "<div id=\"V-EDC9C968-FCE6-4C1E-80B8-3FEBAC76522B\"> <div data-b-component=\"content\" data-b-comp-content=\"{Binding decoratorComponent}\" class=\"stretch-content\"> </div> </div> ";
// Exports
export default code;